import React, { createContext, useEffect, useMemo, useState } from "react";
import axios from "../api/axios";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [auth, setAuth] = useState({});

  const [isAuthenticated, setIsAuthenticated] = useState(false);

  /*
  const [isAuthenticated, setIsAuthenticated] = useState(
    JSON.parse(localStorage.getItem("isAuthenticated")) || false,
  );
*/

  useEffect(() => {
    // const persistState = localStorage.getItem("isAuthenticated");

    // if (persistState) {
    //   setIsAuthenticated(JSON.parse(persistState));
    // }

    // Check authentication status on mount
    const checkAuthStatus = async () => {
      try {
        await axios.get("auth/verify");
        setIsAuthenticated(true);
      } catch (error) {
        setIsAuthenticated(false);
      }
    };

    checkAuthStatus();
  }, []);

  /*

  // useEffect(() => {
  //   localStorage.setItem("isAuthenticated", isAuthenticated);
  // }, [isAuthenticated]);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");

    if (storedUser) {
      setAuth(JSON.parse(storedUser));
    }
  }, []);

  const login = (userData) => {
    setAuth(userData);
    localStorage.setItem("user", JSON.stringify(userData));
  };

  const logout = () => {
    setAuth(null);
    localStorage.removeItem("user");
  };
  */

  const contextValue = useMemo(
    () => ({
      auth,
      setAuth,
      isAuthenticated,
      setIsAuthenticated,
    }),
    [auth, isAuthenticated],
  );

  return (
    <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
  );
}

export default AuthContext;
